var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-sprite-setting"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipShow),expression:"tipShow"}],ref:"tipRef",staticClass:"exceeded-tip",on:{"mousedown":function($event){$event.stopPropagation();}}},[_c('span',[_vm._v("您添加的视频已超出了当前页面的时长。点击“增加”可呈现剩余的视频。")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550c40cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emodal/videoSprite/setting.vue
// module id = null
// module chunks = 